import { withTranslation } from 'react-i18next';

import DataTable from '../../../../components/Datatable';
import { getSortKeys, setAdditionalStyles } from '../../../../helpers/table';
import { MATCH_POLICY } from '../brand';
import { definitionColumns, definitionRows } from '../keys';

/**
 * Block 01 — the rule the rest of the page is an answer to.
 *
 * It is first because nothing below it means anything without it. Every figure on this report is
 * the consequence of a definition somebody wrote, and a reader arriving at a shared link did not
 * write it — so the terms, the mode each one was matched in and the single expression they
 * compiled to are stated before any number is.
 *
 * It shows the *applied* definition, not the one in the editor. The scope bar above is where a
 * definition is changed and previewed; this block is the one that was actually sent, so the two
 * can disagree for as long as an edit is unapplied and the page never misattributes figures to a
 * rule that did not produce them.
 */
function RuleSummary({ t, scope }) {
    const columns = definitionColumns(t);
    const rows = definitionRows(t, scope);
    const literal = scope.policy === MATCH_POLICY.LITERAL;

    return (
        <div className="card table-main rounded-main overflow-hidden gsc-tool-block">
            <div className="card-header d-flex justify-content-between">
                <div>
                    <p className="card-title">{t('tools.brand_non_brand.definition.title')}</p>
                    <p className="gsc-tool-sub">
                        {t('tools.brand_non_brand.definition.description')}
                    </p>
                </div>
            </div>

            <div className="card-body">
                <div className="brand-applied-pattern">
                    <h5>{t('tools.brand_non_brand.definition.applied')}</h5>
                    <code className="gsc-tool-expression">{scope.compiledPattern}</code>
                    <p className="gsc-tool-table-note">
                        {t('tools.brand_non_brand.definition.sent_note')}
                    </p>
                </div>

                <DataTable
                    nodes={rows}
                    COLUMNS={columns}
                    sortFns={getSortKeys(columns)}
                    additionalStyles={setAdditionalStyles(columns)}
                    onlyTable
                    notUseDefaultStyle
                    customContainerStyles="gsc-tool-rules-table"
                />

                <p className="gsc-tool-table-note">
                    {literal
                        ? t('tools.brand_non_brand.definition.literal_note')
                        : t('tools.brand_non_brand.definition.regex_note')}
                </p>
                <p className="gsc-tool-table-note">
                    {t('tools.brand_non_brand.definition.not_google')}
                </p>
                <p className="gsc-tool-table-note">
                    {t('tools.brand_non_brand.definition.session_note')}
                </p>
            </div>
        </div>
    );
}

export default withTranslation()(RuleSummary);
